module.exports = __webpack_public_path__ + "img/bg_desktop-AC.291ad7a3.png";